// ============================================================
// LA VITA DEI PRODOTTI SUGLI SCAFFALI
//
// Le scatole erano immobili al millimetro: uno scaffale di oggetti
// perfettamente fermi si legge come una vetrina di cartone, e in un
// negozio che si attraversa a piedi è la cosa che più fa "finto".
// Qui ci sono i due movimenti che le tengono vive.
//
//  1. IL RESPIRO, sempre acceso: la scatola si solleva appena dal
//     ripiano e ci riscende, dondolando di un paio di gradi. Ogni
//     prodotto ha FASE E RITMO PROPRI (dal seme del suo id, vedi
//     semeDaId in scaffali.js): senza, tutto lo scaffale respirerebbe
//     all'unisono e sembrerebbe una fisarmonica, non una fila di
//     oggetti.
//     VA SOLO VERSO L'ALTO (mai sotto la posizione di riposo): la
//     scatola è appoggiata a un ripiano, e scendere vorrebbe dire
//     entrare nel legno.
//
//  2. LA REAZIONE AL MIRINO: il prodotto che stai inquadrando si alza
//     e si ingrandisce un po', e dondola più deciso. È anche
//     informazione, non solo vezzo — dice QUALE scatola prenderesti
//     premendo E, cosa che prima diceva solo la scritta in basso.
//
// UNITÀ: 1 unità di mondo ≈ 0.55 m. Le ampiezze sono piccole apposta:
// un respiro che si nota è un oggetto che galleggia.
//
// I valori si tarano dal pannello Leva "Vita dei prodotti" (?debug) e
// poi si riportano QUI, che è l'unico posto che li rende permanenti.
// ============================================================
export const cfgVita = {
  attiva: true,
  respiro: 0.02,        // di quanto si solleva dal ripiano (≈ 1 cm reale)
  dondolio: 0.03,       // oscillazione in imbardata (radianti, ≈ 1.7°)
  ritmo: 1,             // moltiplicatore di velocità del respiro
  miraAlza: 0.06,       // quanto sale il prodotto nel mirino (≈ 3 cm)
  miraIngrandisce: 0.07, // +7% di scala nel mirino
  miraVelocita: 9,      // rapidità con cui reagisce al mirino (1/s)
}

// In ?debug è raggiungibile da console (window.__vita) e si può anche
// scrivere: gli slider riscrivono questo oggetto solo quando si muovono
// davvero, quindi un valore assegnato a mano resta.
if (typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).has('debug')) {
  window.__vita = cfgVita
}
